import type { HTMLProps } from 'react'

import { campaignHooks } from 'features/campaigns'
import { type ContactsTable, LoadingButton, StackIcon } from 'shared/ui'

export function AddButton({
	className,
	filters,
	unSelectAll
}: HTMLProps<HTMLButtonElement> &
	Pick<
		ContactsTable.Types.ActionsProps,
		'amount' | 'filters' | 'unSelectAll'
	>) {
	const { campaign } = campaignHooks.useCurrent()

	const [add, isLoading] = campaignHooks.useValidateAddContacts({
		onSuccess: unSelectAll
	})

	return (
		<LoadingButton
			className={className}
			isLoading={isLoading}
			onClick={() => campaign && add(filters, campaign!)}
		>
			<StackIcon icon='plus' />
			Add to campaign
		</LoadingButton>
	)
}
